export const docCopy = {
  doc_layout_title: "El punto de partida para aprender TypeScript",
  doc_layout_description:
    "Encuentra proyectos iniciales de TypeScript: desde Angular hasta React o Node.js y CLIs.",
  doc_headline: "Comienza a aprender",
  doc_headline_ts_for_js_title: "TS para JS",
  doc_headline_ts_for_js_blurb:
    "Una visión general de TypeScript para ingenieros con conocimientos de JavaScript",
  doc_headline_ts_first_title: "Comienza con TS",
  doc_headline_ts_first_blurb:
    "Una introducción para principiantes a JavaScript y TypeScript",
  doc_headline_handbook_title: "Manual",
  doc_headline_handbook_blurb: "La referencia al lenguaje de TypeScript",
  doc_headline_examples_title: "Ejemplos",
  doc_headline_examples_blurb:
    "Completos tutoriales prácticos en el Playground",
  doc_start_a_project: "¡Inicie un proyecto!",
  doc_start_a_project_desc:
    "Debido a que TypeScript es un superconjunto de JavaScript, no tiene una plantilla por defecto - habría demasiadas. En su lugar, otros proyectos tienen sus propias plantillas de TypeScript con su propio contexto. Estos proyectos proporcionan plantillas que incluyen soporte para TypeScript.",
  doc_node_npm: "Node con npm",
  doc_node_npm_tsdx_blurb:
    "Herramienta sin configuraciones extras para construir librerías en TypeScript",
  doc_node_npm_oclif_blurb:
    "Crea herramientas de línea de comandos que a tus usuarios les encantan",
  doc_node_npm_gluegun_blurb:
    "Un encantador juego de herramientas para construir aplicaciones de línea de comandos con TypeScript.",
  doc_frameworks: "Marcos de trabajo de la web",
  doc_frameworks_angular_blurb:
    "Hace que escribir aplicaciones hermosas sea alegre y divertido",
  doc_frameworks_ember_blurb:
    "Un marco para los desarrolladores de sitios web ambiciosos",
  doc_frameworks_react_blurb:
    "Una libreria de JavaScript para construir interfaces de usuario",
  doc_frameworks_vue_blurb: "El marco de JavaScript progresivo",
  doc_frameworks_ror_blurb:
    "El marco web de convención por encima de configuración",
  doc_frameworks_asp_blurb:
    "Marco para la construcción de aplicaciones modernas, basadas en la nube y conectadas a Internet",
  doc_apis: "Node APIs",
  doc_apis_azure_blurb: "Construye y despliega desde VS Code en minutos",
  doc_apis_feather_blurb:
    "Un marco para las aplicaciones en tiempo real y las API de tipo REST",
  doc_apis_graphql_blurb: "Arranque su servidor GraphQL en segundos",
  doc_apis_nest_blurb:
    "Un marco de trabajo progresivo de Node.js para construir aplicaciones eficientes y escalables del lado del servidor",
  doc_apis_node_blurb:
    "Una plantilla documentada cortesía del equipo de TypeScript",
  doc_apis_wechat_blurb:
    "Utiliza el kit de desarrollo WeChat JSSDK con TypeScript",
  doc_react: "Projectos en React",
  doc_react_create_blurb:
    "Configurar una aplicación web moderna ejecutando un comando",
  doc_react_gatsby_blurb:
    "Ayuda a los desarrolladores a crear sitios web y aplicaciones de gran velocidad",
  doc_react_next_blurb: "El marco React",
  doc_react_razzle_blurb:
    "Aplicaciones JavaScript universales renderizadas por el servidor sin configuración",
  doc_react_toolchains_title: "Conjunto de herramientas recomendadas",
  doc_react_toolchains_blurb: "Recomendaciones del equipo de React",
  doc_apps: "Construyendo aplicaciones",
  doc_apps_electron_blurb:
    "Configurar una aplicación web moderna ejecutando un comando",
  doc_apps_expo_blurb: "La forma más rápida de construir una aplicación",
  doc_apps_react_native_blurb: "Aprende una vez, escribe en cualquier lugar",
  doc_apps_native_script_blurb:
    "Marco de código abierto para la construcción de aplicaciones móviles verdaderamente nativas",
  doc_apps_make_code_blurb:
    "Da vida a la informática para todos los estudiantes con proyectos divertidos",
  doc_tooling: "Herramientas",
  doc_tooling_babel_blurb: "Usa la próxima generación de JavaScript, hoy",
  doc_tooling_parcel_blurb:
    "Un paquete de aplicaciones web muy rápido y sin configuración.",
  doc_tooling_webpack_blurb:
    "Agrupa tus recursos, archivos, imágenes y estilos",
  doc_learn: "¿Ya estás familiarizado con TypeScript?",
  doc_learn_3_5_release_notes_title: "Notas de lanzamiento",
  doc_learn_3_5_release_notes_blurb: "Notas de lanzamiento versión",
  doc_learn_handbook_blurb: "La referencia al lenguaje de TypeScript",
  doc_learn_d_ts_title: "Guía para definiciones en TypeScript (d.ts)",
  doc_learn_d_ts_blurb: "Aprende a declarar la forma de JS",
  doc_learn_playground_blurb: "Explora y comparte TypeScript en línea",
}
